import { FunctionComponent } from "react";
import { Marker } from "@vis.gl/react-google-maps";
import { useTranslation } from "react-i18next";
import { getIsQueryStringTruthy, getQueryStringValueTyped } from "@lib/url";
import { isNil } from "@lib/isNil";

import "./CurrentLocationPin.css";

const CurrentLocationPin: FunctionComponent = () => {
  const latitude = getQueryStringValueTyped("latitude", Number);
  const longitude = getQueryStringValueTyped("longitude", Number);
  const kioskMode = getIsQueryStringTruthy("kiosk");

  const { t } = useTranslation();

  if (!kioskMode || isNil(latitude) || isNil(longitude)) {
    return null;
  }

  return (
    <Marker
      position={{ lat: latitude!, lng: longitude! }}
      icon={{
        url: "/images/you-are-here-map-pin.svg",
      }}
      label={{
        text: t("map.youAreHere"),
        className: "you-are-here-pin",
      }}
    />
  );
};

export { CurrentLocationPin };
